export const isSolanaAddress = (address: string | undefined): boolean => {
    if (!address) {
        return false
    } else {
        return /^[A-HJ-NP-Za-km-z1-9]{32,44}$/.test(address)
    }
}
